import { Modal, ModalBody, ModalHeader, Button } from "reactstrap";
import React, { useRef } from "react";
import { useToggle } from "../../custom-hooks/customs";
import axios from "axios";
import { routes } from "../../gen/General";
import Alerts from "../../util/Alerts";

export const ModalEliminarUsuario = ({ id, userAccount, getUsuariosVamGen }) => {
    const { open, toggleOpen } = useToggle();
    const alert = useRef();
    const body = {
        cdAdicional: id,
    };

    function doDelete() {
        id &&
            axios
                .post(routes.api + "/users/delete/", body)
                .then(() => {
                    getUsuariosVamGen();
                    alert.current.show_info("Eliminado exitosamente");
                })
                .catch(error => {
                    alert.current.show_error("Error al eliminar el registro: ", error);
                });
        toggleOpen(false);
    }

    return (
        <>
            <Alerts ref={alert} />
            <Button variant="outlined" color="primary" onClick={toggleOpen}>
                Eliminar
            </Button>

            <Modal centered={true} isOpen={open} toggle={toggleOpen}>
                <ModalHeader>¿Estás seguro?</ModalHeader>
                <ModalBody>
                    <p>¿Deseas eliminar al usuario: {userAccount}?</p>
                </ModalBody>
                <div className="modal-footer">
                    <Button color="primary" onClick={doDelete}>
                        Sí
                    </Button>
                    <Button color="secondary" onClick={toggleOpen}>
                        No
                    </Button>
                </div>
            </Modal>
        </>
    );
};
